import script from "./email-message.vue?vue&type=script&setup=true&lang=js"
export * from "./email-message.vue?vue&type=script&setup=true&lang=js"

import "./email-message.vue?vue&type=style&index=0&id=f437888e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f437888e"]])

export default __exports__